export const CountryCodeList = [
    { value: '852', label: 'Hong Kong' },
    { value: '81', label: 'Japan' },
]
